module.exports = __webpack_public_path__ + "static/img/tip.9095df9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/tip.png
// module id = 43
// module chunks = 1